import { execFileSync } from 'node:child_process';
import { existsSync, statSync } from 'node:fs';

import { getGitRepoRootSync } from '../../git/get-git-repo-root-sync.js';
import { tryWorkspaceDisplayToPath } from './workspace-files.js';

function gitHeadPathObjectType(sessionParentPath: string, displayPath: string): string | null {
  if (!displayPath || displayPath.includes('..')) return null;
  const gitRoot = getGitRepoRootSync(sessionParentPath);
  if (!gitRoot) return null;
  try {
    return execFileSync('git', ['cat-file', '-t', `HEAD:${displayPath}`], {
      cwd: gitRoot,
      encoding: 'utf8',
    }).trim();
  } catch {
    return null;
  }
}

export function getSessionFileChangeDirectoryFlags(sessionParentPath: string, displayPath: string): {
  isDirectory: boolean;
  directoryRemoved: boolean;
} {
  const resolvedPath = tryWorkspaceDisplayToPath(sessionParentPath, displayPath);
  if (resolvedPath && existsSync(resolvedPath)) {
    try {
      if (statSync(resolvedPath).isDirectory()) {
        return { isDirectory: true, directoryRemoved: false };
      }
      return { isDirectory: false, directoryRemoved: false };
    } catch {
      return { isDirectory: false, directoryRemoved: false };
    }
  }
  if (gitHeadPathObjectType(sessionParentPath, displayPath) === 'tree') {
    return { isDirectory: true, directoryRemoved: true };
  }
  return { isDirectory: false, directoryRemoved: false };
}

/** True when path is a directory on disk, or a directory removed since HEAD (git tree, path missing). */
export function isDirectorySessionPath(sessionParentPath: string, displayPath: string): boolean {
  return getSessionFileChangeDirectoryFlags(sessionParentPath, displayPath).isDirectory;
}
